import axios from "axios";
import { API_BASE_URL } from "../config/config.js";

// Fetch all home images
export const fetchAllHomeImages = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}admin/home-images/all/`);
    return response.data.data; 
  } catch (error) {
    console.error("Error fetching home images:", error);
    throw error;
  }
};